import React from 'react'
import { PolicyLayout } from '../../shared/PolicyLayout'
import { P } from '../../shared/P'
import Footer from '../components/Footer'

export default function Terms() {
  return <><PolicyLayout title="Terms & Conditions" icon="📜" sub="Last updated: January 1, 2025">
  <div className="bg-blue-50 border border-blue-200 rounded-2xl p-5 text-sm text-blue-800 font-medium">By using GamapaFoods, you agree to these terms. Please read them before placing your first order.</div>
  <P title="1. Acceptance">Using our website, app or placing an order constitutes acceptance. We may update terms with 30 days notice for material changes.</P>
  <P title="2. Orders & Payment">Orders are binding upon confirmation. Prices include applicable taxes. We accept Visa, Mastercard, UPI, NetBanking and Cash on Delivery.</P>
  <P title="3. Delivery">We aim for 30-minute delivery but this is a target, not a guarantee. We are not liable for delays caused by traffic, weather or force majeure events.</P>
  <P title="4. Age Requirement">You must be 18 or older to create an account. You are responsible for all orders placed under your account.</P>
  <P title="5. Allergens">Our kitchens handle nuts, dairy, gluten and eggs. We cannot guarantee allergen-free meals. Customers with severe allergies must call us before ordering.</P>
  <P title="6. Intellectual Property">All content — logos, images, recipes, text — is owned by GamapaFoods and protected by copyright law.</P>
  <P title="7. Governing Law">These terms are governed by Indian law with jurisdiction in Hyderabad, Telangana.</P>
</PolicyLayout> 
 <Footer />
  </>
}
